
import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { RouterLink } from "@angular/router";
import { isInIframe } from "@app/helpers/iframe-helper";
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { IBreadcrumb } from "@interfaces/iBreadcrumb";
import { TranslationService } from "@services/translation.service";

@Component({
	selector: "app-breadcrumb",
	templateUrl: "./breadcrumb.component.html",
	styleUrls: ["./breadcrumb.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgTemplateOutlet, RouterLink, TranslatePipe]
})
export class BreadcrumbComponent implements OnInit {
	constructor(private translationService: TranslationService, private sanitizer: DomSanitizer) { }
	public target: string

	@Input() breadcrumbs: IBreadcrumb[];

	ngOnInit() {
		this.target = isInIframe() ? '_blank' : undefined
	}

	getDivider() {
		return this.sanitizer.bypassSecurityTrustResourceUrl('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTBwdCIgaGVpZ2h0PSIxMHB0IiB2aWV3Qm94PSIwIDAgMTAgMTAiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDpyZ2IoMCUsMCUsMCUpO2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAyLjcwMzEyNSA4LjM4NjcxOSBMIDMuNDQxNDA2IDkuMTI1IEwgNy41NjY0MDYgNSBMIDMuNDQxNDA2IDAuODc1IEwgMi43MDMxMjUgMS42MTMyODEgTCA2LjA4OTg0NCA1IFogTSAyLjcwMzEyNSA4LjM4NjcxOSAiLz4KPC9nPgo8L3N2Zz4K');
	}
}
